import { getUserFacingErrorText } from "./utilities/userFacingError";

export const hasCompleteCredentialEmailTarget = ({
  adminConsoleLoginEmail,
  chamberMemberId,
}: {
  adminConsoleLoginEmail?: string | null;
  chamberMemberId?: string | null;
}): boolean =>
  Boolean(adminConsoleLoginEmail?.trim() && chamberMemberId?.trim());

// Wave 1 (Oct 19 2026): the shared error rule (userFacingError.ts).
export const getCredentialEmailErrorMessage = ({
  error,
  fallbackMessage,
}: {
  error: unknown;
  fallbackMessage: string;
}): string => getUserFacingErrorText(error, fallbackMessage);
